/**
 * Handles toggling logic for the Learn More / Show Less buttons.
 * Supports multiple paragraphs of `.learn-more-text`.
 * Automatically resets to default state on page reload.
 */

export function setupLearnMoreToggle(): void {
  const showMoreBtn = document.getElementById("show-more");
  const showLessBtn = document.getElementById("show-less");
  const learnMoreTexts = document.querySelectorAll(".learn-more-text") as NodeListOf<HTMLElement>;

  if (!showMoreBtn || !showLessBtn || learnMoreTexts.length === 0) return;

  // --- Default state ---
  const setDefaultState = () => {
    showMoreBtn.style.display = "inline-block";
    showLessBtn.style.display = "none";
    learnMoreTexts.forEach((p) => (p.style.display = "none"));
  };

  // Run on load
  setDefaultState();

  // When "Learn more" is clicked
  showMoreBtn.addEventListener("click", () => {
    showMoreBtn.style.display = "none";
    showLessBtn.style.display = "inline-block";
    learnMoreTexts.forEach((p) => (p.style.display = "block"));
  });

  // When "Show less" is clicked
  showLessBtn.addEventListener("click", () => {
    setDefaultState();
  });

  // --- Reset when page is refreshed (good UX consistency) ---
  window.addEventListener("beforeunload", setDefaultState);
}
